module.exports = __webpack_public_path__ + "img/account.09cc834b.svg";